import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";

const salesContractValidationSchema = Yup.object().shape({
  sales_contract_no: Yup.string().required("Contract No is required"),
  is_captcha_verified: Yup.boolean()
    .oneOf([true], "Please verify CAPTCHA to proceed")
    .required("Please verify CAPTCHA to proceed"),
});
export type SalesContractCloneFormType = Yup.InferType<
  typeof salesContractValidationSchema
>;

const CloneSalesContractModal = ({
  selectedContractNo,
  isOpenCloneModal,
  toggleCloneModal,
  confirmClone,
}: {
  selectedContractNo: string | null;
  isOpenCloneModal: boolean;
  toggleCloneModal: () => void;
  confirmClone: (data: any) => void;
}) => {
  const salesContractCloneInitialValues: SalesContractCloneFormType = {
    sales_contract_no: selectedContractNo || "",
    is_captcha_verified: false,
  };
  const [cloneModalSubmitLoading, setCloneLoading] = useState<boolean>(false);

  const handleSubmit = async (values: SalesContractCloneFormType) => {
    setCloneLoading(true);
    confirmClone(values);
    setCloneLoading(false);
  };

  return (
    <>
      {isOpenCloneModal && (
        <div
          className={`modal fade ${isOpenCloneModal ? "show" : ""}`}
          id="verifiedDocumentModal"
          aria-labelledby="verifiedDocumentModalLabel"
          aria-hidden={!isOpenCloneModal}
          tabIndex={-1}
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-simple modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body p-4">
                <div className="text-center">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={toggleCloneModal}
                  />

                  <p style={{ fontSize: "25px" }}>Are you sure?</p>
                  <p style={{ fontSize: "20px" }}>
                    Do you want to <b>Clone</b> this <b>sales contract</b>?
                  </p>
                </div>

                <Formik
                  enableReinitialize
                  initialValues={salesContractCloneInitialValues}
                  validationSchema={salesContractValidationSchema}
                  onSubmit={handleSubmit}
                  validateOnMount={true}
                >
                  {({ setFieldValue, isValid }) => (
                    <Form className="dt_adv_search">
                      <div className="mx-5">
                        <label
                          htmlFor="sales_contract_no"
                          className="form-label"
                        >
                          Clone Contract No:
                          <span className="text-danger">*</span>
                        </label>
                        <Field
                          id="sales_contract_no"
                          name="sales_contract_no"
                          type="text"
                          className="form-control"
                          placeholder="Enter Contract No"
                        />
                        <ErrorMessage
                          name="sales_contract_no"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="d-flex flex-column align-items-center my-4">
                        <ReCAPTCHA
                          sitekey={
                            process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY ||
                            ""
                          }
                          onChange={(value) => {
                            setFieldValue("is_captcha_verified", !!value);
                          }}
                        />
                        <ErrorMessage
                          name="is_captcha_verified"
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="text-center mt-5">
                        <button
                          type="submit"
                          className="btn btn-primary me-3"
                          disabled={!isValid}
                        >
                          {cloneModalSubmitLoading && (
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                          Yes, Clone
                        </button>

                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          onClick={toggleCloneModal}
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CloneSalesContractModal;
